import { FunctionComponent } from 'react';
import toast from 'react-hot-toast';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../providers/UserProvider';
import { RoleEnum } from '../types/auth';

/**
 * Ce layout contient la mise en page de la partie rôle standard et ce qui s'y rapporte.
 */
export const RoleStandardLayout: FunctionComponent = () => {
  /**
   * On a besoin des informations de l'utilisateur.
   */
  const { user } = useUser();

  /**
   * Si l'utilisateur n'est pas un gestionnaire de centre on le redirige vers la page de connexion.
   * Sinon on affiche le contenu des routes du rôle standard.
   */
  if (user !== null && !user.roles.includes(RoleEnum.standard)) {
    toast.error('Accès refusé.');
    return <Navigate to='/connexion' />;
  } else {
    return <Outlet />;
  }
};
